// Pinned to en-US so output does not vary with the viewer's browser locale.
export const formatPercentFromFraction = (fraction: number): string =>
  new Intl.NumberFormat("en-US", { style: "percent", maximumFractionDigits: 2 }).format(fraction);
